module.exports = __webpack_public_path__ + "img/icon-lotto-hitec.5a0b92f7.png";